try {
    window.$ = window.jQuery = require('jquery');
    window.SimpleMDE = require('simplemde')

    require('bootstrap5');

} catch (e) {
}
